import { render, staticRenderFns } from "./data13.vue?vue&type=template&id=7aa5b8e6&scoped=true&"
import script from "./data13.vue?vue&type=script&lang=js&"
export * from "./data13.vue?vue&type=script&lang=js&"
import style1 from "./data13.vue?vue&type=style&index=1&id=7aa5b8e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa5b8e6",
  null
  
)

export default component.exports